import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useApiClient } from '@/api/clients/useApiClient.util.ts';
import { CustomerSearchResponseDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { CustomTableRequestModel } from '@/models/CustomTableRequest.model.ts';
import { CustomerSearchFormModel } from '@/views/customers/list/model/CustomersSearchForm.model.ts';

type Req = CustomTableRequestModel<CustomerSearchFormModel>;

type Return = {
  getCustomers: (req: Req) => Promise<CustomerSearchResponseDto>;
  isLoading: boolean;
};

export const useGetCustomers = (): Return => {
  const { customersApi } = useApiClient();

  const { isPending, mutateAsync } = useMutation<CustomerSearchResponseDto, AxiosError, Req>({
    meta: { disableSuccessAlert: true },
    mutationFn: async req => {
      const res = await customersApi.searchCustomers(req.page, req.pageSize, {
        ...req.params,
        fullTextSearchInput: req.params.fullTextSearchInput ?? '',
        ownerIdOfCustomerContact: req.params.ownerIdOfCustomerContact?.value ?? undefined,
      });

      return res.data;
    },
    mutationKey: [QueryKeyEnum.CUSTOMERS.ALL],
  });

  return {
    getCustomers: mutateAsync,
    isLoading: isPending,
  };
};
